export default __webpack_public_path__ + "assets/c13a523129d4aa9c5063c690d0d8e9b7.svg";